import { useEffect, useState } from "react";
import "./ReplyModal.css";

function ReplyModal({
  review,
  onClose,
  onSubmit,
}) {
  const [reply, setReply] = useState("");

  useEffect(() => {
    if (review?.reply) {
      setReply(review.reply);
    } else {
      setReply("");
    }

    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [review]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!reply.trim()) return;

    onSubmit(reply);
  };

  if (!review) return null;

  return (
    <div className="reply-overlay">

      <div className="reply-modal">

        <div className="reply-header">

          <h2>
            {review.reply
              ? "Edit Reply"
              : "Reply to Customer"}
          </h2>

          <button
            className="close-btn"
            onClick={onClose}
          >
            ×
          </button>

        </div>

        <div className="customer-review">

          <h4>{review.customerName}</h4>

          <p>{review.review}</p>

        </div>

        <form onSubmit={handleSubmit}>

          <label>Your Reply</label>

          <textarea
            rows="6"
            placeholder="Write your reply..."
            value={reply}
            onChange={(e) =>
              setReply(e.target.value)
            }
          />

          <div className="reply-footer">

            <button
              type="button"
              className="cancel-btn"
              onClick={onClose}
            >
              Cancel
            </button>

            <button
              type="submit"
              className="send-btn"
            >
              {review.reply
                ? "Update Reply"
                : "Send Reply"}
            </button>

          </div>

        </form>

      </div>

    </div>
  );
}

export default ReplyModal;